import { jsx as _jsx } from "react/jsx-runtime";
import CustomerDataProvider, { useCustomerData } from "@cinch-labs/customer-data-segment";
import cx from "classnames";
import { useEffect } from "react";
import BlackFridayBanner from "./black-friday";
import DepositContributionBanner from "./deposit-contribution/deposit-contribution";
import InfoBanner from "./info-banner";
import { default as SalePromoBanner } from "./sale";
import styles from "./shared-ui-promo-banner.module.css";
import SpringSalePromoBanner from "./spring-sale/spring-sale-promo-banner";
import WinterSale from "./winter-sale";
import { default as XmasPromoBanner } from "./xmas";
export function SharedPromoBanner(props) {
    return /*#__PURE__*/ _jsx(CustomerDataProvider, {
        children: /*#__PURE__*/ _jsx(PromoBanner, {
            ...props
        })
    });
}
function PromoBanner({ name , sendDigitalDataEvent , className  }) {
    const { trackEvent  } = useCustomerData();
    useEffect(()=>{
        trackEvent({
            type: "track",
            eventName: "Promotion Viewed",
            data: {
                name,
                position: "top banner"
            }
        });
    }, []);
    const ComponentMap = new Map([
        [
            "sale",
            /*#__PURE__*/ _jsx(SalePromoBanner, {
                sendDigitalDataEvent: sendDigitalDataEvent
            })
        ],
        [
            "xmas",
            /*#__PURE__*/ _jsx(XmasPromoBanner, {})
        ],
        [
            "info",
            /*#__PURE__*/ _jsx(InfoBanner, {})
        ],
        [
            "winter-sale",
            /*#__PURE__*/ _jsx(WinterSale, {
                sendDigitalDataEvent: sendDigitalDataEvent
            })
        ],
        [
            "blackFriday",
            /*#__PURE__*/ _jsx(BlackFridayBanner, {
                sendDigitalDataEvent: sendDigitalDataEvent
            })
        ],
        [
            "deposit-contribution",
            /*#__PURE__*/ _jsx(DepositContributionBanner, {
                sendDigitalDataEvent: sendDigitalDataEvent
            })
        ],
        [
            "spring-sale",
            /*#__PURE__*/ _jsx(SpringSalePromoBanner, {
                sendDigitalDataEvent: sendDigitalDataEvent
            })
        ]
    ]);
    const Child = ComponentMap.get(name);
    if (!Child) return null;
    return /*#__PURE__*/ _jsx("div", {
        className: cx(styles.container, className, {
            [styles.depositContributionContainer]: name === "deposit-contribution",
            [styles.containerInfo]: name === "info" || name === "spring-sale"
        }),
        children: Child
    });
}
